import { FetchElementAuthorizationsInvite } from 'globalTypes'

import { Trans } from '@lingui/macro'

import LevelButton from './LevelButton'
import RemoveButton from './RemoveButton'

interface Props {
  elementId: string
  invite: FetchElementAuthorizationsInvite
}

const Invite = ({ elementId, invite }: Props) => {
  return (
    <div className="flex flex-row gap-1 p-3" key={invite.id} role="listitem">
      <div className="flex-grow flex flex-col my-auto text-sm text-gray-600">
        <div className="font-medium">{invite.id}</div>
        <div className="italic text-gray-400">
          <Trans>Indirizzo email non confermato.</Trans>
        </div>
      </div>
      <LevelButton
        elementId={elementId}
        email={invite.id}
        level={invite.authorization}
      />
      <RemoveButton elementId={elementId} email={invite.id} />
    </div>
  )
}

export default Invite
